<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable :min-width="160" @resizing="onResize" :max-width="400" :draggable="false"
            :handles="['mr']" :w="206" :parent="false">
            <el-scrollbar>
              <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.num')">
                    <el-select v-model="formInline.selectCarType" style="width: 120px"
                      :placeholder="$t('common.choseTip')" class="selectStyle">
                      <el-option v-for="item in optionsInput" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input size="mini" v-model="formInline.selectCarValue" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="inputStyle"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.maintenanceTime')">
                    <el-date-picker v-model="formInline.MaintainTime" type="datetimerange" style="width: 220px"
                      size="mini" value-format="yyyy-MM-dd HH:mm:ss" range-separator
                      :start-placeholder="$t('common.choseTime')" end-placeholder></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t("common.btn.search") }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('REPAIRORDER_ADD')" type="text" @click="addMaintain">{{
                  $t("VehicleManagement.maintain") }}</el-button>
                <el-button v-if="isPrimaryKey('REPAIRFORM_REMINDER')" type="text" @click="down">{{
                  $t("common.btn.download")
                }}</el-button>
              </div>
              <i-table :list="list" :height="height" ref="carTable" @handleSelectionChange="handleSelectionChange"
                :options="option" :columns="columns" :operates="operates"></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
              <el-dialog width="620px" :before-close="closeDia" class="addDialong"
                :title="$t('VehicleManagement.maintain')" :visible.sync="dialogFormVisible"
                :close-on-click-modal="false">
                <el-form :rules="rules" ref="form" :model="form">
                  <el-form-item prop="carId" :label="$t('common.carId') + ':'" :label-width="formLabelWidth">
                    <el-select v-model="form.carId" filterable :placeholder="$t('common.choseTip')">
                      <el-option v-for="item in carList" :key="item.carId" :label="item.carId"
                        :value="item.carId"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="userName" :label="$t('VehicleManagement.operateUser') + ':'"
                    :label-width="formLabelWidth">
                    <el-input disabled size="small" v-model="form.userName" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item prop="operateTime" :label="$t('VehicleManagement.operateTime') + ':'"
                    :label-width="formLabelWidth">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                      :placeholder="$t('common.btn.choseDate')" v-model="form.operateTime"></el-date-picker>
                  </el-form-item>
                  <el-form-item prop="repairType" :label="$t('VehicleManagement.repairType') + ':'"
                    :label-width="formLabelWidth">
                    <el-select v-model="form.repairType" :placeholder="$t('VehicleManagement.form.repairType')">
                      <el-option v-for="item in typeList" :key="item.id" :label="item.dictValue"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="repairDescription" :label="$t('common.remark') + ':'"
                    :label-width="formLabelWidth">
                    <el-input size="small" v-model="form.repairDescription" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item prop="peopleCost" :label="$t('VehicleManagement.peopleCost') + ':'"
                    :label-width="formLabelWidth">
                    <el-input size="small" v-model="form.peopleCost" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item prop="filePath" :label="$t('common.picture')" :label-width="formLabelWidth"
                    style="margin-top: 20px">
                    <el-upload class="avatar-uploader" :action="processImg" list-type="picture-card"
                      :file-list="FileList" :limit="4" :on-success="handleAvatarSuccess"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible" append-to-body class="imgForm">
                      <img width="100%" :src="imageUrl" alt="" class="avatar" />
                    </el-dialog>
                  </el-form-item>
                  <div style="margin-top: 10px; font-size: 16px">
                    {{ $t("VehicleManagement.repariContent") }}
                  </div>
                  <partsRow ref="diaTable" @computedPrice="computedPrice"></partsRow>
                  <p style="text-align: right">
                    {{ $t("VehicleManagement.totalMoneny") }}{{ form.allCost }}
                  </p>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button size="small" @click="cancle('form')">{{
                    $t("common.btn.cancel")
                  }}</el-button>
                  <el-button size="small" type="primary" @click="submitForm('form')">{{
                    $t("common.btn.confirm")
                  }}</el-button>
                </div>
              </el-dialog>
              <el-dialog width="620px" :before-close="closeOperateDia" class="addDialong"
                :title="$t('common.btn.operateDetail')" :visible.sync="dialogOperateVisible"
                :close-on-click-modal="false">
                <el-form ref="OperateForm" :model="OperateForm">
                  <el-form-item prop="serialNumber" :label="$t('Details.repairOrderSerial') + ':'"
                    :label-width="OperateLabelWidth">
                    <el-input size="small" v-model="OperateForm.serialNumber" autocomplete="off"
                      disabled></el-input>
                  </el-form-item>
                  <!-- <el-form-item prop="carId" :label="$t('common.carId') + ':'" :label-width="OperateLabelWidth">
                    <el-input size="small" v-model="OperateForm.carId" autocomplete="off" disabled></el-input>
                  </el-form-item>
                  <el-form-item prop="carWorkTime" :label="$t('VehicleManagement.carWorkTime') + ':'"
                    :label-width="OperateLabelWidth">
                    <el-input size="small" v-model="OperateForm.carWorkTime" autocomplete="off" disabled></el-input>
                  </el-form-item> -->
                  <el-form-item prop="userName" :label="$t('VehicleManagement.operateUser') + ':'"
                    :label-width="OperateLabelWidth">
                    <el-input size="small" v-model="OperateForm.userName" autocomplete="off" disabled></el-input>
                  </el-form-item>
                  <el-form-item prop="operateTime" :label="$t('VehicleManagement.operateTime') + ':'"
                    :label-width="OperateLabelWidth">
                    <el-date-picker value-format="yyyy-MM-dd" type="date" :placeholder="$t('common.btn.choseDate')"
                      v-model="OperateForm.operateTime" disabled></el-date-picker>
                  </el-form-item>
                  <el-form-item prop="repairTypeStr" :label="$t('Details.faultClassification') + ':'"
                    :label-width="OperateLabelWidth">
                    <el-select v-model="OperateForm.repairTypeStr" :placeholder="$t('VehicleManagement.form.repairType')"
                      disabled>
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :label="$t('VehicleManagement.airStop')" value="1"></el-option>
                      <el-option :label="$t('VehicleManagement.lowOilCount')" value="2"></el-option>
                      <el-option :label="$t('VehicleManagement.lowPowerCount')" value="3"></el-option>
                      <el-option :label="$t('VehicleManagement.lowLiquidLevelCount')" value="4"></el-option>
                      <el-option :label="$t('common.other')" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="description" :label="$t('common.remark') + ':'" :label-width="OperateLabelWidth">
                    <el-input size="small" v-model="OperateForm.description" autocomplete="off" disabled></el-input>
                  </el-form-item>
                  <el-form-item prop="peopleCost" :label="$t('VehicleManagement.peopleCost') + ':'"
                    :label-width="OperateLabelWidth">
                    <el-input size="small" v-model="OperateForm.peopleCost" autocomplete="off" disabled></el-input>
                  </el-form-item>
                  <el-form-item prop="materialCost" :label="$t('Details.materialCost') + ':'"
                    :label-width="OperateLabelWidth">
                    <el-input size="small" v-model="OperateForm.materialCost" autocomplete="off" disabled></el-input>
                  </el-form-item>
                  <el-form-item prop="filePath" :label="$t('common.picture')" :label-width="OperateLabelWidth"
                    style="margin-top: 20px">
                    <el-upload class="avatarOperate-uploader" list-type="picture-card" :action="processImg"
                      :file-list="FileOperateList" :limit="4" :on-preview="handleOperatePictureCardPreview" disabled>
                    </el-upload>
                    <el-dialog :visible.sync="dialogFileOperateVisible" append-to-body class="imgForm">
                      <img width="100%" :src="imageOperateUrl" alt="" class="avatar" />
                    </el-dialog>
                  </el-form-item>
                  <div style="margin-top: 10px; font-size: 16px">
                    {{ $t("VehicleManagement.repariContent") }}
                  </div>
                  <detailsTable ref="detailTable"></detailsTable>
                  <p style="text-align: right">
                    {{ $t("VehicleManagement.totalMoneny")
                    }}{{ OperateForm.sumCost }}
                  </p>
                </el-form>
              </el-dialog>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarRepair from "./CarRepair.js";
export default CarRepair;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
